import { DateParameter } from '@drivingdoc/shared-types/reports';
import Grid from '@mui/material/Grid';

import DatePickerInput from 'components/FormInputs/DatePickerInput';

import { calculateDateFromOffset } from 'utils/reportParameters';

import { resolveMaxDate } from './resolveMaxDate';

interface DateParameterFieldProps {
  parameter: DateParameter;
}

export default function DateParameterField({ parameter }: DateParameterFieldProps) {
  const { config } = parameter;
  const minDate = config?.minDateOffset ? calculateDateFromOffset(config.minDateOffset) : undefined;
  const maxDate = resolveMaxDate(config?.maxDateOffset, config?.allowFutureDates);

  return (
    <Grid size={12}>
      <DatePickerInput name={parameter.name} label={parameter.label} minDate={minDate} maxDate={maxDate} />
    </Grid>
  );
}
